import React, { useRef, useEffect, useState } from "react";
import Select from "react-select";

const BatterySelector = (props) => {

  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(props.value)
  }, [props]);

  const handleChange = (selection) => {
    setValue(selection)
  };

  const list = [
    {
      label: "Dry Cell Battery",
      value: "Dry Cell Battery",
    },
    {
      label: "Wet Cell Battery",
      value: "Wet Cell Battery",
    },
    {
      label: "Mannual Traction",
      value: "Mannual Traction",
    },
    {
      label: "Lithium Battery",
      value: "Lithium Battery",
    },
  ];

  return (
    <Select
      defaultValue={props.defaultValue}
      name="battery"
      options={list}
      className="basic-multi-select"
      classNamePrefix="select"
      onChange={(selection) => {
        handleChange(selection);
        props.setList(selection)
      }}
      value={value == '' ? props.value : value}
    />
  );
};

export default BatterySelector;
